module.exports = __webpack_public_path__ + "img/screening_information.069a031e.png";